import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import '../assets/css/common.css';
import '../assets/css/member-list.css';
import CustomButtons from '../components/CustomButtons';
import { consentService } from '../services/consentService';
import { documentService } from '../services/documentService';

function Consents() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [pending, setPending] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const result = await consentService.getConsents();
        setData(result);
      } catch (err) {
        console.error(err);
        setError('同意・誓約情報の取得に失敗しました。時間をおいて再度お試しください。');
      } finally {
        setLoading(false);
      }
    };
    // 改訂により再署名が必要になった書面
    const fetchPending = async () => {
      try {
        const result = await documentService.getPending();
        setPending(result.pending || []);
      } catch (err) {
        console.error('再署名対象取得エラー:', err);
      }
    };

    fetchData();
    fetchPending();
  }, []);

  const formatDate = (dateStr) => {
    if (!dateStr) return '-';
    const d = new Date(dateStr);
    return d.toLocaleString('ja-JP', {
      timeZone: 'Asia/Tokyo',
      year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit'
    });
  };

  if (loading) {
    return (
      <div className="container">
        <h1 className="text-primary text-center mb-4">同意・誓約</h1>
        <p className="text-center">読み込み中...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="container">
        <h1 className="text-primary text-center mb-4">同意・誓約</h1>
        <div style={{ color: '#d32f2f', background: '#ffeaea', padding: '12px 16px', borderRadius: 4, marginBottom: 16 }}>
          {error}
        </div>
        <CustomButtons
          rightLabel="マイページへ戻る"
          onRightClick={() => navigate('/')}
          leftLabel=""
          leftClassName="d-none"
        />
      </div>
    );
  }

  const pendingOf = (docKey) => pending.find((p) => p.docKey === docKey);

  // 写真使用許可の状態表示
  const renderPhotoStatus = () => {
    if (!data?.photoPermission?.signed) {
      return <span style={{ color: 'red' }}>未署名</span>;
    }
    if (data.photoPermission.approved) {
      return <span style={{ color: 'green', fontWeight: 'bold' }}>承諾済み</span>;
    }
    return <span style={{ color: '#e94e1b', fontWeight: 'bold' }}>不承諾</span>;
  };

  return (
    <div className="container">
      <h1 className="text-primary text-center mb-4">同意・誓約</h1>

      <table className="details-table">
        <thead>
          <tr>
            <th>種別</th>
            <th>状態</th>
            <th>署名日時</th>
            <th>操作</th>
          </tr>
        </thead>
        <tbody>
          {/* 写真使用許可 */}
          <tr>
            <td>
              写真使用許可
              {pendingOf('photo_permission') && (
                <div className="text-small" style={{ color: '#d97706', fontWeight: 'bold' }}>
                  改訂あり（v{pendingOf('photo_permission').signedVersion} → v{pendingOf('photo_permission').currentVersion}）
                </div>
              )}
            </td>
            <td>{renderPhotoStatus()}</td>
            <td>{formatDate(data?.photoPermission?.signedAt)}</td>
            <td>
              <button
                className="btn btn-primary btn-sm"
                onClick={() => navigate(
                  data?.photoPermission?.signed ? '/documents/photo_permission/resign' : '/photo-permission'
                )}
              >
                {pendingOf('photo_permission')
                  ? '再署名する'
                  : data?.photoPermission?.signed ? '変更する' : '署名する'}
              </button>
            </td>
          </tr>

          {/* 秘密保持誓約 */}
          <tr>
            <td>
              秘密保持誓約書
              {pendingOf('confidentiality') && (
                <div className="text-small" style={{ color: '#d97706', fontWeight: 'bold' }}>
                  改訂あり（v{pendingOf('confidentiality').signedVersion} → v{pendingOf('confidentiality').currentVersion}）
                </div>
              )}
            </td>
            <td>
              {data?.confidentiality?.signed ? (
                <span style={{ color: 'green', fontWeight: 'bold' }}>同意済み</span>
              ) : (
                <span style={{ color: 'red' }}>未署名</span>
              )}
            </td>
            <td>{formatDate(data?.confidentiality?.signedAt)}</td>
            <td>
              {pendingOf('confidentiality') ? (
                <button
                  className="btn btn-primary btn-sm"
                  onClick={() => navigate('/documents/confidentiality/resign')}
                >
                  再署名する
                </button>
              ) : data?.confidentiality?.signed ? (
                <span className="text-muted" title="秘密保持誓約書は改訂時を除き変更できません">署名済み（変更不可）</span>
              ) : (
                <button
                  className="btn btn-primary btn-sm"
                  onClick={() => navigate('/confidentiality-agreement')}
                >
                  署名する
                </button>
              )}
            </td>
          </tr>
        </tbody>
      </table>

      <CustomButtons
        rightLabel="マイページへ戻る"
        onRightClick={() => navigate('/')}
        leftLabel=""
        leftClassName="d-none"
      />
    </div>
  );
}

export default Consents;
